<ng-container *transloco="let t; prefix: 'experience'">
  <div class="experience-modal-card">
    @if (experience?.description) {
      <section>
        <h4 class="heading-s">{{ t('theEditorView').toUpperCase() }}</h4>
        <p class="innerHtml" [innerHTML]="experience?.description"></p>
      </section>
    }
    @if (experience?.quote) {
      <section>
        <h4 class="heading-s quote" [innerHTML]="experience?.quote"></h4>
        <span class="editor">
          <h5 class="heading-s">{{ t('wordsBy') }}</h5>
          <p class="name">{{ experience?.editor?.first_name }} {{ experience?.editor?.last_name }}</p>
        </span>
      </section>
    }
    @if (experience?.whatWeLove) {
      <section>
        <h4 class="heading-s">{{ t('whatWeLove').toUpperCase() }}</h4>
        <p class="innerHtml" [innerHTML]="experience?.whatWeLove"></p>
      </section>
    }
    @if (experience?.address?.full_address) {
      <section>
        <h4 class="heading-s">{{ t('location').toUpperCase() }}</h4>
        <a href="{{ experience?.address?.mapsUrl }}" target="_blank">{{ experience?.address?.full_address }}</a>
      </section>
    }
  </div>
</ng-container>
